module.exports = __webpack_public_path__ + "static/media/2 (48).0186e7d8.jpg";